module.exports = __webpack_public_path__ + "static/logo-4940120132f88b28f4bb35eed2132380.png";